import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import useStateRef from 'react-usestateref';
import { Link,useNavigate } from "react-router-dom";
import Card from "../../../../../components/Card";
import swal from 'sweetalert';
//import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import Select from 'react-select';
import "../../../../App.css";
import { collapseClasses } from '@mui/material';


const TableData = () => {

  const [DtDetTable, setDtDetTable, DtDetTableRef]=useStateRef([]);
  let DetTable=[];
 const [SaveButtonText, setSaveButtonText] = useState("Save");
 
 
  useEffect(() => {

    sessionStorage.getItem("MetalIssue_EditElg")==='true' ?  setDisabled(''):  setDisabled('disabled');
   
	
	
   if(sessionStorage.getItem("MetalIssue_Action")=="Add")
   {
	    setSaveButtonText("Save");
      document.getElementById("optGold").checked=true;
      document.getElementById("optSmith").checked=true;
     
    document.getElementById("txtIssueNo").value="{Auto}";
    document.getElementById("txtIssueDate").value=(new Date()).toISOString().substring(0,10);
   
	//Clear();
   
   }
   else if(sessionStorage.getItem("MetalIssue_Action")=="Edit")
   {
	   setSaveButtonText("Update");
	   Display(sessionStorage.getItem("MetalIssue_EditId"));
   }
   else if(sessionStorage.getItem("MetalIssue_Action")=="Delete")
   {
	   setSaveButtonText("Delete");
	   Display(sessionStorage.getItem("MetalIssue_EditId"));
   }
	
   ControlSettings();

   innitialSetValue();
   

  }, []);
  
  function innitialSetValue() {
   

  getLookup();
 

  getMetalName();
  }

  const [isDisabled, setisDisabled]=useState(false);

  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
 
   const [TMshow1, setTMShow1] = useState(false);
   const TMhandleClose1 = () => setTMShow1(false);
   const TMhandleShow1 = () => setTMShow1(true);
    
   const [localtime,setlocaltime] =useState(new Date());

   const [btndisabled, setDisabled] = useState('disabled');

  const [DtParty, setDtParty]=useState([]);
  const [DtRecType, setDtRecType]=useState([]);
  const [DtOrderNo, setDtOrderNo]=useState([]);
  const [DtMetal, setDtMetal]=useState([]);
  const [DtMetalCatRec, setDtMetalCatRec]=useState([]);
  const [DtRecDetail, setDtRecDetail]=useState([]);
 

  const [AccCode, setAccCode, AccCodeRef] = useStateRef();
  const [MetalNameHead, setMetalNameHead, MetalNameHeadRef] = useStateRef();
  const [MetalCatRecHead, setMetalCatRecHead, MetalCatRecHeadRef] = useStateRef();
 
  const [RecType, setRecType, RecTypeRef] = useStateRef();
  const [MetalCatRec, setMetalCatRec, MetalCatRecRef] = useStateRef();
 
  async function TagPrint()
{
  try
  {
   
    let postData = {
      TagId: document.getElementById("txtIssueNo").value
  }

  

  const results = await apiService.postCall("metalissue/tagprint",postData);


 if (results != "-1") {

 }
}

catch (error) {
  console.log(error);
}
}


  async function openModal()
  {

    let postData = 
    [
      {MetalCode: MetalNameHeadRef.current,
      MetalRecCatCode: MetalCatRecHeadRef.current}
      
    ]

  
   
  const results = await apiService.postCall("metalissue/getrecdetail",postData);


 if (results != "-1") {

  setDtRecDetail(results.data[0]);

  handleShow1();
 }

   

  }



 async function gridAdd () {


  let lstitems= document.getElementsByClassName("lstItems");

  let i=0;
  let idlist=[];
  let cnt=0;
  for(i=0;i<lstitems.length;i++)
  {
    let item=lstitems[i];
    
    if (item.checked==true)
    {
      let r={"GrnNo":item.id};
      idlist[cnt]=r;
      cnt=cnt+1;
    }
  }

  let postData = 
      {GRNList:idlist}
      
  const results = await apiService.postCall("metalissue/getgrnlistdetail",postData);


 if (results != "-1") {

  setDtDetTable(results.data[0]);

  TotalCalc();
  setlocaltime(new Date());
  handleClose1();

  
 }
      




    }

  async function Clear()
   {
          

		handleClose1();
		
   }
 function gridRemove (id) {

  
      
      DetTable=DtDetTable;
       
        var cnt = 0;
        try {
            cnt = DetTable.length;
        }
        catch (err) {
            cnt = 0;
        }
     
      let i=0;

        for (i = 0; i < cnt; i++)
        {
            if (DetTable[i].ID == id)
            {
                DetTable.splice(i, 1);
                break;
            }
        }

			setDtDetTable(DetTable);
      
			setMetalCatRec("");
			
			TotalCalc();
			
      //Clear();

    }

function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}

async function TotalCalc () {

  
      
      DetTable=DtDetTable;
       
        var cnt = 0;
        try {
            cnt = DetTable.length;
        }
        catch (err) {
            cnt = 0;
        }
     
        
        
      let i=0;
		document.getElementById("txtTWt").value="";
		document.getElementById("txtTTWt").value="";
		document.getElementById("txtTPureWt").value="";

        for (i = 0; i < cnt; i++)
        {
      document.getElementById("txtTWt").value=(val(document.getElementById("txtTWt").value)+val(DetTable[i].Balance)).toFixed(3);
			document.getElementById("txtTTWt").value=(val(document.getElementById("txtTTWt").value)+val(DetTable[i].TotalWt)).toFixed(3);
			document.getElementById("txtTPureWt").value=(val(document.getElementById("txtTPureWt").value)+val(DetTable[i].PureWt)).toFixed(3);
			
        }

		

    }


function Calc()
{
  document.getElementById("txtTotalWt").value=parseFloat(document.getElementById("txtWt").value).toFixed(3);
  document.getElementById("txtPureWt").value=(parseFloat(document.getElementById("txtWt").value)*parseFloat(document.getElementById("txtTouch").value)/100).toFixed(3);

  document.getElementById("txtTotalWt").value=(document.getElementById("txtTotalWt").value==="NaN" ? "0" :document.getElementById("txtTotalWt").value );
  document.getElementById("txtPureWt").value=(document.getElementById("txtPureWt").value==="NaN" ? "0" :document.getElementById("txtPureWt").value );


}

async function ControlSettings()
{

  document.getElementById("txtIssueNo").disabled ='true';
  document.getElementById("txtIssueDate").disabled ='true';
  
  
  if((sessionStorage.getItem("MetalIssue_Action")=="Edit") || (sessionStorage.getItem("MetalIssue_Action")=="Delete"))
   {
  

    document.getElementById("optSmith").disabled ='true';
    document.getElementById("optDealer").disabled ='true';
    document.getElementById("optOthers").disabled ='true';

    document.getElementById("optGold").disabled ='true';
    document.getElementById("optSilver").disabled ='true';
    document.getElementById("optDiamond").disabled ='true';
    document.getElementById("optOthers1").disabled ='true';

    setisDisabled('true');

   

   }

 



}

async function Display(EditId){
	  try
    {
     
      let postData = {
        EditId: EditId
    }


  

    const results = await apiService.postCall("metalissue/Display",postData);


   if (results != "-1") {
     
	 let HeadData=results.data.Head;
   let DetailData=results.data.Detail;

  if(HeadData[0][0].OrderType=="SMITH")
  {
    document.getElementById("optSmith").checked=true;
  }
  else if(HeadData[0][0].OrderType=="DEALER")
  {
    document.getElementById("optDealer").checked=true;
  }
  else if(HeadData[0][0].OrderType=="OTHERS")
  {
    document.getElementById("optOthers").checked=true;
  }


  if(HeadData[0][0].MetalType=="GOLD")
  {
    document.getElementById("optGold").checked=true;
  }
  else if(HeadData[0][0].MetalType=="SILVER")
  {
    document.getElementById("optSilver").checked=true;
  }
  else if(HeadData[0][0].MetalType=="DIAMOND")
  {
    document.getElementById("optDiamond").checked=true;
  }
  else if(HeadData[0][0].MetalType=="OTHERS")
  {
    document.getElementById("optOthers1").checked=true;
  }

   getLookup();
   getMetalName();



   document.getElementById("txtIssueNo").value =HeadData[0][0].IssueNo;
   document.getElementById("txtIssueDate").value=HeadData[0][0].IssueDate.substring(0,10);
   setAccCode(HeadData[0][0].AccCode);
   
   document.getElementById("txtPktNo").value=HeadData[0][0].PocketNo;
   document.getElementById("txtRemarks").value=HeadData[0][0].Remarks;

   getMetalName();



   setMetalNameHead(HeadData[0][0].MetalCode1);

   let metalcatlist=[
    {
      value:HeadData[0][0].MetalCatRecCode1,
      label:HeadData[0][0].MetalRecCaty,

    }
   ]

   setDtMetalCatRec(metalcatlist);
   
   setMetalCatRecHead(HeadData[0][0].MetalCatRecCode1);

   DetTable=DetailData[0];

   await setDtDetTable(DetTable);

  
   var cnt = 0;
   try {
       cnt = DetTable.length;
   }
   catch (err) {
       cnt = 0;
   }

   
   
 let i=0;
document.getElementById("txtTWt").value="";
document.getElementById("txtTTWt").value="";
document.getElementById("txtTPureWt").value="";

   for (i = 0; i < cnt; i++)
   {
       document.getElementById("txtTWt").value=(val(document.getElementById("txtTWt").value)+val(DetTable[i].Weight)).toFixed(3);
 document.getElementById("txtTTWt").value=(val(document.getElementById("txtTTWt").value)+val(DetTable[i].TWeight)).toFixed(3);
 document.getElementById("txtTPureWt").value=(val(document.getElementById("txtTPureWt").value)+val(DetTable[i].PureWt)).toFixed(3);
 
   }
   

   }

    
    }
    catch (error) {
      console.log(error);
    }

  }


async function Save(){
	  try
		{
	
if (DtDetTable.length==0)
{
	swal({

      title: "",
      text: "Please Enter Details",
      icon: "info",
      button: "Ok"

    });
	
	return;
}	
			
			
			
		const optary = document.getElementsByName("group_partytype");
		 let optpartytype="";
		 let i;
		 
		 for(i=0;i<optary.length;i++)
		 {
			 if(optary[i].checked==true)
			 {
				  optpartytype=optary[i].value;
			 }
		 }
		 
		 
	const optary1 = document.getElementsByName("group_metaltype");
     let optmetaltype="";
    
     for(i=0;i<optary1.length;i++)
     {
       if(optary1[i].checked==true)
       {
          optmetaltype=optary1[i].value;
       }
     }
		 
		let postData = {
			"Action" : sessionStorage.getItem("MetalIssue_Action"),
			"EditId" : sessionStorage.getItem("MetalIssue_EditId"),
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate":sessionStorage.getItem("FinMinDate").substring(0,10),
			"FinMaxDate":sessionStorage.getItem("FinMaxDate").substring(0,10),
			"EntryUser":sessionStorage.getItem("EntryUser"),
			"IssueDate": document.getElementById("txtIssueDate").value,
			"AccCode": AccCodeRef.current,
			"OrderType": optpartytype,
			"MetalType": optmetaltype,
			"PacketNo": document.getElementById("txtPktNo").value,
			"Remarks": document.getElementById("txtRemarks").value,
      "MetalCode":MetalNameHeadRef.current,
      "MetalRecCode":MetalCatRecHeadRef.current,
			"DetTable1": DtDetTable
		}

  
   const results = await apiService.postCall("metalissue/Save",postData);


  

   if (results != "-1") {

if(results.errorCode=="8888")
{


  swal({

    title: "Alert",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    
  });

  return;

}  
  if(sessionStorage.getItem("MetalIssue_Action")=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }

  else if(sessionStorage.getItem("MetalIssue_Action")=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }
	 
  else if(sessionStorage.getItem("MetalIssue_Action")=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
     BackToList();
   });
 
 }
	 
      }
    }
    catch (error) {
      console.log(error);
    }

  }

  function Calc1(id)
  {
   
    
    let i=0;
  
    DetTable=DtDetTable;
  
   
   
    for(i=0;i<DetTable.length;i++)
    {
      if(id==DetTable[i].GrnNo)
      {
        DetTable[i].TotalWt=val(DetTable[i].Balance);
        DetTable[i].PureWt=parseFloat(val(DetTable[i].TotalWt)*val(DetTable[i].Touch)/100).toFixed(2);
      }  
  }
  setDtDetTable(DetTable);
  
  setlocaltime(new Date());
  
  
  }
  



  async function getMetalName(){
    try
    {

    const optary = document.getElementsByName("group_metaltype");
     let optmetaltype="";
     let i;
     
     for(i=0;i<optary.length;i++)
     {
       if(optary[i].checked==true)
       {
          optmetaltype=optary[i].value;
       }
     }
     
    let postData = {
        optmetaltype: optmetaltype
    }

    
DetTable=[];
TotalCalc();
await setDtDetTable(DetTable);
    


    const results = await apiService.postCall("metalissue/GetMetalType",postData);

   if (results != "-1") {
      setDtMetal(results.data[0]);
      }
    }
    catch (error) {
      console.log(error);
    }

  }

   async function getMetalCatRec(){
    try
    {

   
     let MetalName=MetalNameHeadRef.current;
     
     let postData = {
        MetalName: MetalName
    }
     
    const results = await apiService.postCall("metalissue/GetMetalCatRec",postData);
    
   if (results != "-1") {
      setDtMetalCatRec(results.data[0]);
       
      }
    }
    catch (error) {
      console.log(error);
    }

  }

  function SetGridValue(id,value,Col)
  {
   let i=0;
 
   DetTable=DtDetTable;
 

   for(i=0;i<DetTable.length;i++)
   {
     if(id==DetTable[i].GrnNo)
     {
     

      if (Col=='Weight') 
       DetTable[i].Balance=value;
      else if(Col=='Touch')
      DetTable[i].Touch=value;
     
     }  
 }

 setDtDetTable(DetTable);
 
 setlocaltime(new Date());
 
 Calc1(id);
 
  }
 

  async function getLookup(){
	 try {
		const optary = document.getElementsByName("group_partytype");
		 let optpartytype="";
		 let i;
		 
		 for(i=0;i<optary.length;i++)
		 {
			 if(optary[i].checked==true)
			 {
				  optpartytype=optary[i].value;
			 }
		 }
		 
		 
		let postData = {
        optpartytype: optpartytype
		}
		
		let rectype=[
		{"RecType":"Direct Purchase(Cash)"},
		{"RecType":"Other Receipt"}
		];
		
		setDtRecType(rectype);


    const results = await apiService.postCall("metalissue/Lookup",postData);

	 if (results != "-1") {
			setDtParty(results.data[0]);
      }

    } catch (error) {
      console.log(error);
    }
}

 
  const navigate = useNavigate();
  const BackToList = () => {
    navigate('../dashboard/table/smith/metalissue/list');
  };

  return (
    <>
    <input type="Hidden" id="txtId" />

      <Row>
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">Metal Issue Screen</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <div className='container'>
              <div className='container-fluid'>
                <div className='row'>
                  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='d-flex flex-row justify-content-around'>
                        <div >
                          <Form.Check.Input id="optGold" onChange={getMetalName} value="GOLD"  name="group_metaltype" type="radio" className='me-2' />
                          <Form.Check.Label>GOLD</Form.Check.Label>
                        </div>
                        <div >
                          <Form.Check.Input value="SILVER" id="optSilver" onChange={getMetalName} name="group_metaltype" type="radio" className='me-2' />
                          <Form.Check.Label>SILVER</Form.Check.Label>
                        </div>
                        <div >
                          <Form.Check.Input value="DIAMOND" hidden="hidden" id="optDiamond" onChange={getMetalName} name="group_metaltype" type="radio" className='me-2' />
                          <Form.Check.Label hidden="hidden">DIAMOND</Form.Check.Label>
                        </div>
                        <div >
                          <Form.Check.Input hidden="hidden" value="OTHERS" id="optOthers1" onChange={getMetalName} name="group_metaltype" type="radio" className='me-2' />
                          <Form.Check.Label hidden="hidden" >OTHERS</Form.Check.Label>
                        </div>
                      </div>
                      <div className='container-fluid py-4 '>
                        <div className='row py-2'>
                          <div className='col-md-6'>
                            <Form.Label>Rec No</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" id="txtIssueNo" placeholder="" />
                          </div>
						  
						  
						  <div className='col-md-6'>
                            <Form.Label>Date</Form.Label>
                            <Form.Control type="date" Readonly="Readonly" id="txtIssueDate" placeholder="" />
                          </div>
						  
						  
                          <div className='col-md-12'>

                          

                            <Form.Label>Party Name</Form.Label>


                            <Select className="" id="txtPartyName" 
                             options={DtParty}
                             isDisabled={isDisabled}
                             value={DtParty.filter(function(option) {
                              return option.value === AccCode;
                            })}
                            onChange=
                            {
                              (e) => {

                                 setAccCode(e.value);
                                 
                              }
                              }
                             >
              								
							               </Select>

                            
                          </div>
                        </div>
                        
                        
                      </div>

                    </div>

                  </div>
                  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='d-flex flex-row justify-content-around'>
                        <div >
                          <Form.Check.Input value="SMITH" id="optSmith" name="group_partytype" type="radio" className='me-2' onChange={getLookup} />
                          <Form.Check.Label>SMITH</Form.Check.Label>
                        </div>
                        <div >
                          <Form.Check.Input value="DEALER"  id="optDealer"  name="group_partytype" type="radio" className='me-2' onChange={getLookup} />
                          <Form.Check.Label>DEALER</Form.Check.Label>
                        </div>
                        <div >
                          <Form.Check.Input value="OTHERS" hidden="hidden" id="optOthers"   name="group_partytype" type="radio" className='me-2' onChange={getLookup} />
                          <Form.Check.Label hidden="hidden" >OTHER</Form.Check.Label>
                        </div>
                      </div>
                      <div className='container-fluid py-4 '>
                        <div className='row '>
                          <div className='row py-2'>
                            
                          <div className='col-md-12 py-2'>
                          <Form.Label>Metal Name</Form.Label>
                         
                          <Select className="" id="txtMetalNameHead" 
                             options={DtMetal}
                             isDisabled={isDisabled}
                             value={DtMetal.filter(function(option) {
                              return option.value === MetalNameHead;
                            })}
                            onChange=
                            {
                              (e) => {

                                setMetalNameHead(e.value)
                                getMetalCatRec();
                                 
                              }
                              }
                             >
              								
							               </Select>


                          
                        </div>

                        <div className='col-md-12 py-2'>
                          <Form.Label>Metal Rec Category</Form.Label>
                          <Select className="" id="txtMetalCatRecHead" 
                             options={DtMetalCatRec}
                             isDisabled={isDisabled}
                             value={DtMetalCatRec.filter(function(option) {
                              return option.value === MetalCatRecHead;
                            })}
                            onChange=
                            {
                              (e) => {

                                setMetalCatRecHead(e.value)
                                
                              }
                              }
                             >
              								
							               </Select>
                            
                        </div>


                            <div className='col-md-6' hidden='hidden'>
                              <Form.Label>Pocket No</Form.Label>
                              <Form.Control type="text" id="txtPktNo" placeholder="" />
                            </div>
                          </div>
                          <div className='col-md-12 py-2'>
                            <Form.Label>Remark</Form.Label>
                            <Form.Control type="text" id="txtRemarks" placeholder="" />
                          </div>

                        
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='col-md-2 '>
                    <Form.Label>Weight</Form.Label>
                    <Form.Control type="text" id="txtTWt" Readonly="Readonly" placeholder="" className="txtReadOnly" />
                  </div>
                  <div className='col-md-2 '>
                    <Form.Label>Total Wt</Form.Label>
                    <Form.Control type="text" id="txtTTWt" Readonly="Readonly" placeholder="" className="txtReadOnly" />
                  </div>
                  <div className='col-md-2 '>
                    <Form.Label>Pure Wt</Form.Label>
                    <Form.Control type="text" id="txtTPureWt" Readonly="Readonly" placeholder="" className="txtReadOnly" />
                  </div>                             
                </div>
              </div>
			  
			  
			    
				
				<Modal show={TMshow1} onHide={TMhandleClose1} className=".modal-lg" >
                  <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					</Form.Group>
					 </Modal.Body>
                 </Modal>
				
				
			  
			  <Modal show={show1} onHide={handleClose1} className=".modal-lg" id='MetalIssue_RecDetail' >
                  <Modal.Header closeButton>
                    <Modal.Title>Select Receipt Detail</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					<div className='container-fluid py-12 ' id='MetalIssue_RecDetailTable' >
          <Table striped id="basic-table" className="table-striped mb-0" role="grid">
                  <thead>
                    <tr>
                    <th>Edit</th>
                      <th>Grn No</th>
                      <th>Grn Date</th>
                      <th>Weight</th>                 
                      <th>Balance</th>
            
                    </tr>
                  </thead>
                  <tbody>
                  {DtRecDetail.map((item) => (
                    <tr>
                       <td>
                       <Form.Check className="me-2">
                                        
                                        <Form.Check.Input type="checkbox" className="lstItems" id={item.GrnNo} />
                                        
                                        <Form.Check.Label>{item.GrnNo}</Form.Check.Label>
                                      </Form.Check>
						</td>
		
                      <td>{item.GrnNo}</td>
                      <td>{item.GrnDate.substring(0,10)}</td>
                      <td>{item.Weight}</td>
                      <td>{item.Balance}</td>
                      
                      
		
                    </tr>
                      )
                      )
                       }     
                  </tbody>
                </Table>
</div>

                    </Form.Group>
                    <div style={{ "direction": 'rtl' }}>
                    <Button type="button" className="detbutton" id="cmdDetSave"  variant="btn btn-primary" onClick={gridAdd}>OK</Button>
					<Button type="button" className="detbutton" id="cmdDetNew" variant="btn btn-primary" onClick={Clear}>Cancel</Button>
                       </div>
                  </Modal.Body>
                </Modal>
				
			  

                  
              <div className="table-responsive mt-4" >
			 
				
                <Table striped id="basic-table" className="table-striped mb-0" role="grid">
                  <thead>
                    <tr>
                    <th>GrnNo</th>
                      <th>Metal</th>
                      <th>Catergory Rec</th>
                      <th>Purity</th>                 
                      <th>Weight</th>
                      <th>Total Wt</th>
                      <th>Touch</th>
                      <th>Pure Wt</th>  
                      
						<th>Delete</th>					  
                    </tr>
                  </thead>
                  <tbody>
                  {DtDetTable.map((item) => (
                    <tr>
                      
                      <td>{item.GrnNo}</td>
                      <td>{item.MetalName}</td>
                      <td>{item.MetalRecCaty}</td>
                      <td>{item.Purity}</td>
                      <td><Form.Control type="text" value={item.Balance} id={'Weight' + item.GrnNo} onChange={(e)=>SetGridValue(item.GrnNo,e.target.value,'Weight')}  className='me-2 gridbox'  /></td>
                      <td>{item.TotalWt}</td>
                      <td><Form.Control type="text" value={item.Touch} id={'Touch' + item.GrnNo} onChange={(e)=>SetGridValue(item.GrnNo,e.target.value,'Touch')}  className='me-2 gridbox'  /></td>
                      <td>{item.PureWt}</td>         
                           
                     
		<td>
					 <Link className="btn btn-sm btn-icon text-danger" data-bs-toggle="tooltip" title="Delete" to="#" onClick={(e)=>gridRemove(item.ID)}>
                            <span className="btn-inner">
                              <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                                <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                            </span>
                          </Link>
					</td>
                    </tr>
                      )
                      )
                       }     
                  </tbody>
                </Table>
				<div className="EntryPan">
				 <Button type="button" className="detbutton text-center btn-primary btn-icon btn-sm mt-lg-0  mt-md-0 mt-3 " id="cmdDetAdd"  variant="btn btn-primary" onClick={openModal}>
			  <i className="btn-inner">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                  </i>
				  </Button>
				</div>
              </div>
              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">
                  <Button type="button" variant='btn btn-primary'  onClick={TagPrint}  >
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToList}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary" disabled={btndisabled} onClick={Save}>{SaveButtonText}</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
